import styled from "@emotion/styled";
import {
  MDSActionMenuDropdown,
  MDSIconButton,
  MDSIconButtonSize,
  MDSIconKind,
  MDSMenuDropdownSlotName,
  MDSText,
  MDSTextVariant,
  MDSTooltip,
  MDSTooltipPlacement,
  MDSTooltipTrigger,
  type MDSMenuContentList,
} from "@/mds";
import { AudioCapturePhase } from "@/store/audio/pipeline/audio-capture.types";

interface AudioCaptureHeaderProps {
  phase: AudioCapturePhase;
  activeMicrophoneLabel: string | null;
  isDesktop: boolean;
  dropdownItems: MDSMenuContentList;
  shouldShowDropdown: boolean;
  onDelete: () => void;
}

export function AudioCaptureHeader({
  phase,
  activeMicrophoneLabel,
  isDesktop,
  dropdownItems,
  shouldShowDropdown,
  onDelete,
}: AudioCaptureHeaderProps) {
  const tooltipLabel =
    phase !== AudioCapturePhase.Recording
      ? "Not recording"
      : activeMicrophoneLabel
        ? isDesktop
          ? activeMicrophoneLabel
          : `Recording from device "${activeMicrophoneLabel}"`
        : "No microphone found";

  return (
    <StyledHeaderTop>
      <MDSTooltip config={{ placement: MDSTooltipPlacement.Top, label: tooltipLabel }}>
        <MDSTooltipTrigger>
          <StyledHeaderTitle variant={MDSTextVariant.TextM}>Voice Recording</StyledHeaderTitle>
        </MDSTooltipTrigger>
      </MDSTooltip>
      <RightSide>
        {shouldShowDropdown && (
          <MDSActionMenuDropdown contentList={dropdownItems} placement="bottom">
            <MDSIconButton
              slot={MDSMenuDropdownSlotName.Trigger}
              iconKind={MDSIconKind.GearCode}
              size={MDSIconButtonSize.Medium}
            />
          </MDSActionMenuDropdown>
        )}
        <MDSTooltip config={{ label: "Delete recording", placement: MDSTooltipPlacement.Top }}>
          <CancelRecordingButton onClick={onDelete} iconKind={MDSIconKind.Exit} />
        </MDSTooltip>
      </RightSide>
    </StyledHeaderTop>
  );
}

const StyledHeaderTitle = styled(MDSText)``;

const StyledHeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-right: ${({ theme }) => theme.spacing[1]};
  padding-top: ${({ theme }) => theme.spacing[1]};
  padding-bottom: ${({ theme }) => theme.spacing[2]};
`;

const RightSide = styled.div`
  min-height: 40px;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["1"]};
`;

const CancelRecordingButton = styled(MDSIconButton)`
  min-width: 40px;
`;
